import { Component, Input, TrackByFunction } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { TicketDescriptionPipe } from '../ticket-description.pipe';
import { UtilsService } from '../../../../core/services/utils.service';
import { TicketData } from '../../../../core/modules/tickets/ticket.types';

@Component({
  selector: 'tax-ticket-information',
  templateUrl: './ticket-information.component.html',
  styleUrls: ['./ticket-information.component.sass'],
  standalone: true,
  imports: [
    SharedModule,
    TicketDescriptionPipe,
  ],
})
export class TicketInformationComponent {
  @Input() ticketModel?: TicketData;
  readonly trackByIndex: TrackByFunction<string> = this.utilsService.trackByIndex;

  constructor(private utilsService: UtilsService) {}
}
